import AddProduct from "../../Pages/DashboardPages/AddProduct";
import DashboardHome from "../../Pages/DashboardPages/DashboardHome";
import OrderList from "../../Pages/DashboardPages/OrderList";
import Profile from "../../Pages/DashboardPages/Profile";
import UserRoute from "../../Components/PrivateRoutes/UserRoute";
import AdminRoute from "../../Components/PrivateRoutes/AdminRoute";
import UserList from "./../../Pages/DashboardPages/UserList";
import ProductList from "../../Pages/DashboardPages/ProductList";
import ManageBanner from "../../Pages/DashboardPages/ManageBanner";
import ManageNotice from "./../../Pages/DashboardPages/ManageNotice";
import ManageFaq from "../../Pages/DashboardPages/ManageFaq";
import Invoice from "../../Pages/DashboardPages/Invoice";

export const dashboardRoutes = [
  {
    alias: "",
    title: "Dashboard",
    link: "",
    isAdminRoute: false,
    isPrivateRoute: true,
    isNavListed: true,
    comp: (
      <UserRoute>
        <DashboardHome
          title="Dashboard : Thanos Gaming eShop"
          description="Dashboard Home Page"
          keywords=""
        />
      </UserRoute>
    ),
    icon: "fa fa-gear",
  },
  {
    alias: "",
    title: "My Profile",
    link: "profile/",
    isNavListed: true,
    isAdminRoute: false,
    isPrivateRoute: true,
    comp: (
      <UserRoute>
        <Profile
          title="Profile : Thanos Gaming eShop"
          description="Profile Section of Thanos Gaming eShop"
          keywords=""
        />
      </UserRoute>
    ),
    icon: "fa fa-user",
  },
  {
    alias: "Manage Section",
    title: "Manage Product",
    link: "manage-product/",
    isAdminRoute: true,
    isPrivateRoute: true,
    isNavListed: true,
    comp: (
      <AdminRoute>
        <AddProduct
          title="Manage Product : Thanos Gaming eShop"
          description="Product Management Page"
          keywords=""
        />
      </AdminRoute>
    ),
    icon: "fa fa-plus",
  },
  {
    alias: "Manage Section",
    title: "Manage Product",
    link: "manage-product/:pid",
    isAdminRoute: true,
    isPrivateRoute: true,
    isNavListed: false,
    comp: (
      <AdminRoute>
        <AddProduct
          title="Manage Product : Thanos Gaming eShop"
          description="Product Management Page"
          keywords=""
        />
      </AdminRoute>
    ),
    icon: "fa fa-plus",
  },
  {
    alias: "Manage Section",
    title: "Manage Banner",
    link: "manage-banner/",
    isAdminRoute: true,
    isPrivateRoute: true,
    isNavListed: true,
    comp: (
      <AdminRoute>
        <ManageBanner
          title="Manage Banner : Thanos Gaming eShop"
          description="Banner Management Page"
          keywords=""
        />
      </AdminRoute>
    ),
    icon: "fas fa-newspaper ",
  },
  {
    alias: "Manage Section",
    title: "Manage Notice",
    link: "manage-notice/",
    isAdminRoute: true,
    isPrivateRoute: true,
    isNavListed: true,
    comp: (
      <AdminRoute>
        <ManageNotice
          title="Manage Notice : Thanos Gaming eShop"
          description="Management of Notice section"
          keywords=""
        />
      </AdminRoute>
    ),
    icon: "fa fa-plus-square",
  },
  {
    alias: "Manage Section",
    title: "Manage FAQ",
    link: "manage-faq/",
    isAdminRoute: true,
    isPrivateRoute: true,
    isNavListed: true,
    comp: (
      <AdminRoute>
        <ManageFaq
          title="Manage FAQ : Thanos Gaming eShop"
          description="Frequently Asked Question management section"
          keywords=""
        />
      </AdminRoute>
    ),
    icon: "fa fa-question-circle",
  },
  {
    alias: "List Section",
    title: "Order List",
    link: "order-list/",
    isAdminRoute: false,
    isPrivateRoute: true,
    isNavListed: true,
    comp: (
      <UserRoute>
        <OrderList
          title="Order List : Thanos Gaming eShop"
          description="Order List Management section"
          keywords=""
        />
      </UserRoute>
    ),
    icon: "fa fa-list",
  },
  {
    alias: "List Section",
    title: "Order List",
    link: "order-list/:id",
    isAdminRoute: true,
    isPrivateRoute: true,
    isNavListed: false,
    comp: (
      <AdminRoute>
        <Invoice
          title="Order List : Thanos Gaming eShop"
          description="Order List Management section"
          keywords=""
        />
      </AdminRoute>
    ),
    icon: "fa fa-list",
  },
  {
    alias: "List Section",
    title: "User List",
    link: "user-list/",
    isAdminRoute: true,
    isPrivateRoute: true,
    isNavListed: true,
    comp: (
      <AdminRoute>
        <UserList
          title="User List : Thanos Gaming eShop"
          description="User list Section of thanos gaming eShop"
          keywords=""
        />
      </AdminRoute>
    ),
    icon: "fa fa-list",
  },
  {
    alias: "List Section",
    title: "User Profile",
    link: "user-list/:id",
    isAdminRoute: true,
    isPrivateRoute: true,
    isNavListed: false,
    comp: (
      <AdminRoute>
        <Profile
          title="Profile : Thanos Gaming eShop"
          description="User Profile Section"
          keywords=""
        />
      </AdminRoute>
    ),
    icon: "fa fa-user",
  },
  {
    alias: "List Section",
    title: "Product List",
    link: "product-list/",
    isAdminRoute: true,
    isPrivateRoute: true,
    isNavListed: true,
    comp: (
      <AdminRoute>
        <ProductList
          title="Product List : Thanos Gaming eShop"
          description="Product List management and view section"
          keywords=""
        />
      </AdminRoute>
    ),
    icon: "fa fa-list",
  },
];
